import e from "./DomHandler.js";
function l(e, l) {
  for (var t = 0; t < l.length; t++) {
    var n = l[t];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
  }
}
function t(e, l, t) {
  return l in e ? Object.defineProperty(e, l, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[l] = t, e;
}
var n = function () {
  var n, r;
  function i(e) {
    var l = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : function () {};
    !function (e, l) {
      if (!(e instanceof l)) throw TypeError("Cannot call a class as a function");
    }(this, i), t(this, "element", void 0), t(this, "listener", void 0), t(this, "scrollableParents", void 0), this.element = e, this.listener = l;
  }
  return n = [{
    key: "bindScrollListener",
    value: function value() {
      this.scrollableParents = e.getScrollableParents(this.element);
      for (var l = 0; l < this.scrollableParents.length; l++) this.scrollableParents[l].addEventListener("scroll", this.listener);
    }
  }, {
    key: "unbindScrollListener",
    value: function value() {
      if (this.scrollableParents) for (var e = 0; e < this.scrollableParents.length; e++) this.scrollableParents[e].removeEventListener("scroll", this.listener);
    }
  }, {
    key: "destroy",
    value: function value() {
      this.unbindScrollListener(), this.element = null, this.listener = null, this.scrollableParents = null;
    }
  }], l(i.prototype, n), r && l(i, r), i;
}();
export { n as default };